import script from "./CategoryDialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./CategoryDialog.vue?vue&type=script&lang=ts&setup=true"

import "./CategoryDialog.vue?vue&type=style&index=0&id=ed7bbc5c&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ed7bbc5c"]])

export default __exports__